"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _requestStatusChecks = require("../../utils/requestStatusChecks");

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _RequestStatusTypes = require("../../constants/RequestStatusTypes");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var LoadingHOC = function LoadingHOC(_ref) {
  var children = _ref.children,
      requestStatuses = _ref.requestStatuses,
      _ref$grow = _ref.grow,
      grow = _ref$grow === void 0 ? true : _ref$grow,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? 200 : _ref$minHeight,
      _ref$unrecoverableFai = _ref.unrecoverableFailure,
      unrecoverableFailure = _ref$unrecoverableFai === void 0 ? false : _ref$unrecoverableFai,
      successMarker = _ref.successMarker,
      failureMarker = _ref.failureMarker;

  if (unrecoverableFailure && _requestStatusChecks.anyRequestsFailed.apply(void 0, (0, _toConsumableArray2.default)(requestStatuses))) {
    return _react.default.createElement(_react.default.Fragment, null, failureMarker, _react.default.createElement(_UIErrorMessage.default, {
      className: "loading-hoc-failure-message"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "settingsuilib.unrecoverableError"
    })));
  } else if (_requestStatusChecks.allRequestsFinished.apply(void 0, (0, _toConsumableArray2.default)(requestStatuses))) {
    return _react.default.createElement("div", null, successMarker, children);
  }

  return _react.default.createElement(_UILoadingSpinner.default, {
    grow: grow,
    minHeight: minHeight
  });
};

LoadingHOC.propTypes = {
  children: _react.PropTypes.node.isRequired,
  grow: _react.PropTypes.bool,
  minHeight: _react.PropTypes.number,
  requestStatuses: _react.PropTypes.arrayOf(_RequestStatusTypes.RequestStatusPropType).isRequired,
  unrecoverableFailure: _react.PropTypes.bool,
  spinner: _react.PropTypes.bool,
  successMarker: _react.PropTypes.node,
  failureMarker: _react.PropTypes.node
};
var _default = LoadingHOC;
exports.default = _default;
module.exports = exports.default;